import axios from "axios";
import cloneDeep from "lodash/cloneDeep";

const state = {
  productsRandom: [],

  productsRandomStatus: false,
  lastPageRandom: null,
  currentPageRandom: 0,
};

const getters = {
  getProductsRandom(state) {
    return state.productsRandom;
  },
  getProductsRandomStatus(state) {
    return state.productsRandomStatus;
  },
  getProductsRandomLastPage(state) {
    return state.lastPageRandom;
  },
  getProductsRandomCurrentPage() {
    return state.currentPageRandom;
  },
  getProductsRandomLastPage(state) {
    return state.lastPage;
  },
};

const mutations = {
  setProductsRandom(state, products) {
    state.productsRandom = products;
  },
  setProductsRandomStatus(state, status) {
    state.productsRandomStatus = status;
  },
  setLastPageProductsRandom(state, page) {
    state.lastPageRandom = page;
  },
  setCurrentPageProductsRandom(state, page) {
    state.currentPageRandom = page;
  },
};

const actions = {
  async getProductsRandomFromServer({ commit }, payLoad) {
    let query = cloneDeep(payLoad.query);
    console.log(query, "payLoadpayLoadpayLoad");
    query = { page: payLoad.query.page };
    commit("setProductsRandomStatus", true);
    try {
      const response = await axios.get("front/products-random", {
        params: query,
      });
      console.log(response.data.data.paginated.data);

      // commit(
      //   "setProductsRandom",
      //   response.data.data.paginated.data
      //   // state.productsAll.concat(response.data.data.products.data)
      // );
      commit(
        "setProductsRandom",
        payLoad.newList
          ? response.data.data.paginated.data
          : state.productsRandom.concat(response.data.data.paginated.data)
      );
      commit(
        "setLastPageProductsRandom",
        response.data.data.paginated.last_page
      );
      commit(
        "setCurrentPageProductsRandom",
        response.data.data.paginated.current_page
      );

      commit("setProductsRandomStatus", false);
    } catch (error) {}
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
